module.exports = __webpack_public_path__ + "img/img26.d8db572b.png";